import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, NavLink } from "react-router";
import Modal from 'react-modal';
import { useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header";
import "../style/Login.css";
import { X, Eye, EyeOff } from 'lucide-react';
// images
import triedPlayingImg from "/images/tried-playing.svg";

const Login = observer(() => {
  const profilStore = useProfilStore();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectInfo = location.state;
  const [redirectionIsOpen, setRedirectionIsOpen] = useState((redirectInfo&&redirectInfo.reason)?true:false);

  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [showMdp, setShowMdp] = useState(false);

  const styleModal = {
    content: {
      position: 'static',
      zIndex: '1000',
      borderRadius : '0.5rem',
      border : '2px solid #fff',
      borderStyle: 'double',
      backgroundColor: '#221D23',
      width: 'auto',
      maxWidth: '85vw',
      // display //
      display: 'flex',
      flexDirection: 'column', 
      gap: '2rem',
    },
    overlay: {
      zIndex: '1000',
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      // display //
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };

  // If the user is already connected, he send him into the Home page
  useEffect(() => {
    if (profilStore.isConnected) {
      navigate("/Profil");
    }
  }, [profilStore, navigate]);

  

  function closeModalRedirection() {
    setRedirectionIsOpen(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await profilStore.connect(mail, password);
      if (redirectInfo && redirectInfo.reason === "triedPlaying") {
        navigate("/play/param");
      } else {
        navigate("/profil");
      }
    } catch (error) {
      if (error.message === "user-not-found") {
        navigate("/sign", { state: { mail } });
      } else if (error.message === "wrong-password") {
        alert("Mot de passe incorrect !");
      } else {
        alert("Erreur inconnue : " + error.message);
      }
    }
  };



  return (
    <>
      <main className="login_main">
      <Header/>
        <div className="login_mainContent">
          <h2 className="login_title">Connexion</h2>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login_mailDiv">
              <input
                className="login_mailInput"
                id="login_mailInput"
                type="email"
                placeholder=""
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required
              />
              <label htmlFor="login_mailInput" className="login_mailLabel">
                Mail*
              </label>
            </div>
            <div className="login_mdpDiv">
              <input
                className="login_mdpInput"
                id="login_mdpInput"
                type={showMdp?`text`:`password`}
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label htmlFor="login_mdpInput" className="login_mdpLabel">
                Mot de passe*
              </label>
              <button onMouseDown={()=>setShowMdp(true)} onMouseUp={()=>setShowMdp(false)} type='button' className='login_mdpButton'>
                {showMdp ? <EyeOff color='#fff'/> : <Eye color='#fff'/>}
              </button>
            </div>
            <div className='login_connectDiv'>
              <button type="submit" className="login_connectInput">Se connecter</button>
              <NavLink className="login_signButton" to={`/sign`}>S'inscrire</NavLink>
            </div>
          </form>
        </div>
        <Modal bodyOpenClassName="modal-open2" style={styleModal} isOpen={redirectionIsOpen} onRequestClose={closeModalRedirection}>
          <div className='login_modalHeaderDiv'>
            <h2 className='login_modalMainTitle'>
              {redirectInfo && redirectInfo.reason==="triedPlaying" ? `Connectez-vous avant de jouer`:``}
            </h2>
            <button onClick={closeModalRedirection} className='login_modalCloseButton'>
              <X className='login_modalCloseSvg' size={32}/>
            </button>
          </div>
          <img className='login_triedPlayingImage' src={triedPlayingImg} alt="Personne regardant sa fenetre de nuit" />
        </Modal>
      </main>
    </>
  );
});

export default Login;


